import React, { useState } from 'react';

function NewsletterForm() {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [template, setTemplate] = useState('');
    const [scheduledDateTime, setScheduledDateTime] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://dgm-backend.vercel.app/api/send-newsletter', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ subject, message, imageUrl, template, scheduledDateTime }),
            });

            const data = await response.json(); // Parse JSON response

            if (response.ok) {
                setResponseMessage(data.message || 'Newsletter scheduled successfully');
                setError('');
            } else {
                setError(data.error || 'Failed to schedule newsletter. Please try again.');
            }
        } catch (error) {
            setError('Failed to schedule newsletter. Please try again.');
        }
    };

    return (
        <div className="container py-4">
            <h2>Schedule Newsletter</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label htmlFor="subject" className="form-label">Subject</label>
                    <input
                        type="text"
                        className="form-control"
                        id="subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        required
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="message" className="form-label">Message</label>
                    <textarea
                        className="form-control"
                        id="message"
                        rows="4"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        required
                    ></textarea>
                </div>
                <div className="mb-3">
                    <label htmlFor="imageUrl" className="form-label">Image URL (optional)</label>
                    <input
                        type="text"
                        className="form-control"
                        id="imageUrl"
                        value={imageUrl}
                        onChange={(e) => setImageUrl(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="template" className="form-label">HTML Template (optional)</label>
                    <textarea
                        className="form-control"
                        id="template"
                        rows="6"
                        value={template}
                        onChange={(e) => setTemplate(e.target.value)}
                    ></textarea>
                </div>
                <div className="mb-3">
                    <label htmlFor="scheduledDateTime" className="form-label">Scheduled Date/Time</label>
                    <input
                        type="datetime-local"
                        className="form-control"
                        id="scheduledDateTime"
                        value={scheduledDateTime}
                        onChange={(e) => setScheduledDateTime(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="btn btn-primary">Schedule Newsletter</button>
                {responseMessage && <p className="text-success mt-2">{responseMessage}</p>}
                {error && <p className="text-danger mt-2">{error}</p>}
            </form>
        </div>
    );
}

export default NewsletterForm;
